import { AmplitudeService } from 'app/shared/services/amplitude.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "./amplitude.service";
import * as i2 from "@angular/router";
var AmplitudeRouteListenerService = /** @class */ (function () {
    function AmplitudeRouteListenerService(amplitudeService, router) {
        this.amplitudeService = amplitudeService;
        this.router = router;
    }
    AmplitudeRouteListenerService.prototype.startListening = function () {
        var _this = this;
        this.router.events
            .pipe(filter(function (event) { return event instanceof NavigationEnd; }), map(function (event) { return _this.getRootPath(event.url); }), filter(function (url) { return url !== _this.previousUrl; }))
            .subscribe(function (url) {
            _this.amplitudeService.logEvent('Panel: Route change', {
                url: url
            });
            _this.previousUrl = url;
        });
    };
    AmplitudeRouteListenerService.prototype.getRootPath = function (url) {
        var urlWithoutLeadingSlash = url.substring(1);
        var firstSlash = urlWithoutLeadingSlash.indexOf('/');
        if (firstSlash === -1 || urlWithoutLeadingSlash.trim() === '') {
            return url;
        }
        return '/' + urlWithoutLeadingSlash.substring(0, firstSlash);
    };
    AmplitudeRouteListenerService.ngInjectableDef = i0.defineInjectable({ factory: function AmplitudeRouteListenerService_Factory() { return new AmplitudeRouteListenerService(i0.inject(i1.AmplitudeService), i0.inject(i2.Router)); }, token: AmplitudeRouteListenerService, providedIn: "root" });
    return AmplitudeRouteListenerService;
}());
export { AmplitudeRouteListenerService };
